const getConstants = (): any => {
  const accountValidationMessages = {
    nom: [
      {type: 'required', message: 'Ce champ est obligatoire'},
    ],
    emailAddress: [
      {type: 'required', message: 'Email est obligatoire'},
      {type: 'email', message: 'Veuillez saisir une adresse e-mail valide'},
    ],
    titre: [
      {type: 'required', message: 'titre est obligatoire'},
    ],
  };

  const maxSize = 15728640;  // la valeur est en Byte qui correspond a 15 MB
  const maxSizeInMB = (maxSize / (1024 * 1024)).toFixed(2);

  const notificationMessage = {
    notificationDisplayDuration: 10000,
    errorNotification: 'Il y a des erreurs.',
    emailSuccessNotification: 'Merci! Votre message a été envoyé avec succès.',
    maxSizeFileWarning: `Le fichier choisi dépasse La taille maximale (${parseInt(maxSizeInMB)} Mo) permise.`

  };


  const messages = {
    waringMessage: 'êtes-vous sûr de vouloir le supprimer?',
    maxSizeFileInfo: `* la taille du fichier ne doit pas dépasser ${parseInt(maxSizeInMB)} Mo.`
  };

  const sizeLabelField = {
    minLengthLabel: 1,
    maxLengthLabel: 80,
    maxLengthDescription: 250
  };

  const fieldsLimit = {
    radioLimit: 2,
    checkboxLimit: 1,
  };

  const FieldsNullValues = {
    List: {value: null, render: ''},
    Radio: {value: null, render: ''}
  };
  const MIN_TEXT_LENGTH = 1;
  const MIN_MOTIF_LENGTH = 5;

  const allowedExtensionsFile = new Map<string, any>([
    ['images', ['image/*']], // ou ['images'], ['.jpg', '.jpeg', '.png', '.gif', '.tif']
    ['Excel, Libre Calc', ['.xls', '.xlsx', '.odf']],
    ['Word, Libre Writer', ['.doc', '.docx', '.odt']],
    ['PDF', ['.pdf']],
    ['Texte', ['.txt']]
  ]);

  const allowMultiple = false;

  return {
    accountValidationMessages,
    notificationMessage,
    messages,
    sizeLabelField,
    fieldsLimit,
    FieldsNullValues,
    MIN_TEXT_LENGTH,
    allowedExtensionsFile,
    maxSize,
    allowMultiple,
    MIN_MOTIF_LENGTH
  };
};

export const Constants = getConstants();
